/**
 * Created by aaikepae on 6/1/17.
 */


import React from 'react';
import { getLanguage } from "../../../utility/browser"
import "./_index.scss";

import { setRobotsNoindex } from '../../../utility/head';
import SEO from '../../../utility/seo';

const s3 = window.PUBHUB_CONTENT_URL;
const type = PUBHUB_TYPE || "site";


export default class extends React.Component {

    componentDidMount() {
        let { projectName, route } = this.props;
        let location = this.props.phlocation;
        if (!location) {
            location = `${s3}${projectName}/${type}/`;
        }

        this.mountSDK(location, {
            baseURL: route["url"] ? route["url"] : `/site/${projectName}/`
        })
    }

    componentWillUpdate(nextProps, nextState) {
        if (this.props.projectName !== nextProps.projectName && window["site"]) {
            let { projectName, route } = nextProps;
            site.clear();
            site.router.baseURL = route["url"] ? route["url"] : `/site/${projectName}/`;
            let location = nextProps.phlocation;
            if (!location) {
                location = `${s3}${projectName}/${type}/`;
            }
            site.configURL = location + "web.json";
        }
    }

    componentWillUnmount() {
        if (this.site) {
            this.site.unmount();
        }
    }


    mountSDK(location, params = {}) {

        PubHub.env = CONFIG["PUBHUB_ENV"];

        const site = PubHub.createSitePage({
            container: document.getElementById("devnet-site")
        });

        site.router.baseURL = params["baseURL"];


        site.defaultLanguage = getLanguage();
        site.configURL = location + "web.json";

        // site.on("configDataLoaded", (event) => {
        //
        //
        // });

        // for testing header
        site.on("configDataLoaded", (event) => {
            // site.store.getState().config.location = site._location.replace("https://pubhub.devnetcloud.com/media/",window.PUBHUB_CONTENT_URL)
            event.detail.data.meta.location = event.detail.data.meta.location.replace("https://pubhub.devnetcloud.com/media/", window.PUBHUB_CONTENT_URL);

            if (!event.detail.data.meta.indexed) {
                setRobotsNoindex();
            }
        })

        site.on("configDataError", (event) => {
            this.props.setReady();
            this.props.setError();
        })

        site.on("contentError", () => {
            this.props.setReady();
            this.props.setError();
        })

        site.on("load", (event) => {
            const data = event.detail.data;
            if (window.location.pathname == "/site/index/") {
              const title = SEO.parseSeoTitleTag(data.content) || data.meta.name;
              const description = SEO.parseSeoDescriptionTag(data.content) || data.meta.description || CONFIG["PAGE_DESCRIPTION"];
              
              setTimeout(() => {
                AnalyticsSDK.setMetaDataTags(title, description);
              }, 1);
            } else {
                const title = SEO.parseTitle(data.content) || data.meta.name;
                const description = SEO.parseDescription(data.content) || data.meta.description || CONFIG["PAGE_DESCRIPTION"];
                const fullTitle = ((title == data.meta.name) ? `${title}` : `${title} - ${data.meta.name}`) + ' - Cisco DevNet';
                const fullDescriptioin = `${title} - ${description}`;
                
                setTimeout(() => {
                  AnalyticsSDK.setMetaDataTags(fullTitle, fullDescriptioin);
                }, 1);
            }
        });

        site.on("rendered", () => {
            this.props.setReady();
        });

        window.site = this.site = site;
    }


    render() {
        return (
            <div id="devnet-site"></div>
        )
    }
}
